module.exports = __webpack_public_path__ + "static/media/jpg.e1077e1a.png";